import React from 'react';
import {Link} from 'react-router-dom';
import styles from './Button.module.css';
import {ArrowRightIcon, PlayIcon, CopyIcon} from '../icons/Icons';

const ICONS = {
    arrow: ArrowRightIcon,
    play: PlayIcon,
    copy: CopyIcon,
};

// Shared pill button/link. `to` renders a router Link, `href` renders an <a>,
// otherwise a <button>. `variant` and `size` map straight to the design tokens.
const Button = ({
    variant = 'primary',
    size = 'section',
    icon,
    iconPosition = 'end',
    roundIcon,
    to,
    href,
    className = '',
    children,
    ...rest
}) => {
    const classes = `${styles.btn} ${styles[variant] || ''} ${styles[size] || ''} ${className}`;
    const Icon = icon && ICONS[icon];
    const iconEl = Icon && (roundIcon ? <span className={styles.iconCircle}><Icon/></span> : <Icon/>);
    const content = (
        <>
            {iconEl && iconPosition === 'start' && iconEl}
            {children}
            {iconEl && iconPosition === 'end' && iconEl}
        </>
    );

    if (to) {
        return <Link to={to} className={classes} {...rest}>{content}</Link>;
    }
    if (href) {
        return <a href={href} className={classes} {...rest}>{content}</a>;
    }
    return <button type="button" className={classes} {...rest}>{content}</button>;
};

export default Button;
